<template>
  <div class="top-bar top-bar--has-height header" v-show="display">
  
    <banner v-if="showAuthBanner || getHeaderBannerState" @closeBanner="closeBanner"></banner> <!-- DEV NOTE: this component has to globalized -->
    <div class="home-live-section">
      <div class="kidjo-home" :class="focusKidjoWorldLink ? 'active' : ''" v-if="showHomeButton"
       @click="goToKidjoWorld">
        <vue-lottie class="lottie-player" :options="homeOptions" :name="'ic_home'"/>
        <img src="@/assets/icons/home.svg" alt="Kidjo-world" >
      </div>
      <div class="live-btn" @click.prevent="goLive">
        <div class="lottie-player">
          <vue-lottie :options="liveOptions" :name="'ic_live'"/>
        </div>
        <img src="@/assets/icons/live.svg"  alt="Live">
      </div>
    </div>
    <div class="user-controls">
      <div class="search" :class="focusSearchLink ? 'active' : ''" @click="showSearch">
        <vue-lottie class="lottie-player" :options="searchOptions" :name="'ic_search'"/>
        <img src="@/assets/icons/search.svg" alt="Search">
      </div>
      <div class="settings settings-button" :class="focusSettings ? 'active' : ''" @click="showSettings">
          <span>{{getAge?.minAge || defaultAge.minAge}}-{{getAge?.maxAge || defaultAge.maxAge}}</span>
            <div class="lottie-player">
              <vue-lottie :options="lockOptions" :name="'ic_lock'"/>
            </div>
            <img src="@/assets/icons/settings-lock.svg" alt="Lock" class="" />
      </div>
    </div>
  </div>
</template>

<script>
  import LiveService from '@/services/live.service';
  import { soundList, soundPlayer } from '@/utils/sounds';
  import SettingStorage from '@/utils/settings.storage';
  import Banner from '@/components/Banner.vue';
  import { itemList } from '@/utils/settings.options';
  import { isNonEmptyStr } from '@/utils';
  // import LottiePlayer from '@/components/LottiePlayer.vue';
  const kidjoWorld = process.env.VUE_APP_KIDJO_WORLD_BASE_URL
  import VueLottie from 'vue-lottie';
  // import 'vue-lottie/dist/vue-lottie.css';

  export default {
    components: { Banner, VueLottie },
    data() {
      return {
        defaultAge: {
          minAge: 3,
          maxAge: 8
        },
        excludedRoutes: ['player', 'gaming', 'settings', 'folder', 'game', 'search'],
        isUserPremium: this.getPremium,
        active: false,
        display: true,
        showAuthBanner: false,
        searchOptions: {
          animationData: require('@/assets/animations/ic_search.json'),
          loop: true,
          autoplay: true,
        },
        homeOptions: {
          animationData: require('@/assets/animations/ic_home.json'),
          loop: true,
          autoplay: true,
        },
        lockOptions: {
          animationData: require('@/assets/animations/ic_lock.json'),
          loop: true,
          autoplay: true,
        },
        liveOptions: {
          animationData: require('@/assets/animations/ic_live.json'),
          loop: true,
          autoplay: true,
        }
      };
    },
    computed: {
      isAgeSettingDisplayed() {
        return this.$store.getters['settings/isAgeSettingDisplayed'];
      },
      getToken() {
        return this.$store.getters['account/getToken'];
      },
      focusSettings() {
        return this.$store.getters['settings/focusSettings'];
      },
      focusLiveLink() {
        return this.$store.getters['settings/focusLiveLink'];
      },
      focusKidjoWorldLink() {
        return this.$store.getters['settings/focusKidjoWorldLink'];
      },
      focusSearchLink() {
        return this.$store.getters['settings/focusSearchLink'];
      },
      activeHeaderNav() {
        return this.$store.getters['settings/activeHeaderNav'];
      },
      getContentType() {
        return this.$store.getters['settings/getContentType'];
      },
      getBannerState() {
        return this.$store.getters['settings/getBannerState'];
      },
      getHeaderBannerState() {
        return this.$store.getters['settings/getHeaderBannerState'];
      },
      getAge() {
        return this.$store.getters['settings/getAge'];
      },
      getPremium() {
        return this.$store.getters['account/getPremium'];
      },
      showHomeButton() {
        const excludedStores = ['cafeyn', 'orange', 'virgo', 'docomo'];
        return !this.isVewd() && !excludedStores.includes(this.$store.getters["account/getStoreId"]);
      }
    },
    methods: {
      getUserGenerateKey() {
        return this.$store.dispatch('account/getUserGenerateKey');
      },
      displayAgeSetting(val) {
        this.$store.dispatch('settings/displayAgeSetting', val);
      },
      setFocusLiveLink(val) {
        this.$store.dispatch('settings/setFocusLiveLink', val);
      },
      setFocusSearchLink(val) {
        this.$store.dispatch('settings/setFocusSearchLink', val);
      },
      setFocusSettings(val) {
        this.$store.dispatch('settings/setFocusSettings', val);
      },
      setFocusKidjoWorldLink(val) {
        this.$store.dispatch('settings/setFocusKidjoWorldLink', val);
      },
      setActiveHeaderBarNav(val) {
        this.$store.dispatch('settings/setActiveHeaderBarNav', val);
      },
      ageSettingFor(setting) {
        this.$store.dispatch('settings/ageSettingFor', setting);
      },
      setVideoList(list) {
        this.$store.dispatch('settings/setVideoList', list);
      },
      setLiveMode(val) {
        this.$store.dispatch('settings/setLiveMode', val);
      },
      setBannerState(val) {
        this.$store.dispatch('settings/setBannerState', val);
      },
      setHeaderBannerState(val) {
        this.$store.dispatch('settings/setHeaderBannerState', val);
      },
      closeBanner() {
        this.showAuthBanner = false;
        this.setHeaderBannerState(false);
      },
    async  goToKidjoWorld () {
      soundPlayer(soundList.general);
       if (isNonEmptyStr(this.getToken)) {
        await this.$store.dispatch('account/getUserGenerateKey').then((response) => {
          if (response.status === 200) {
            this.$store.dispatch('account/resetUserToken');
            console.log('response.data.redirectKey', response.data.redirectKey);
            window.location.href =
            kidjoWorld +
              '?key=' +
              response.data.redirectKey;
          }
          }).catch(() => {
            window.location.href = kidjoWorld;
          })
        } else {
          window.location.href = kidjoWorld;
        }
      },
      handleKeyboard(event) {
        if (this.activeHeaderNav && !this.getBannerState) {
          event.preventDefault();
          try {
            switch (event.keyCode) {
              case VK_DOWN: {
                this.setActiveHeaderBarNav(false);
                this.setFocusLiveLink(false);
                this.setFocusSettings(false);
                this.setFocusSearchLink(false);
                this.setFocusKidjoWorldLink(false);
                break;
              }
              case VK_RIGHT: {
                if (this.focusKidjoWorldLink) {
                  this.setFocusKidjoWorldLink(false);
                  this.setFocusLiveLink(true);
                } else if (this.focusLiveLink) {
                  this.setFocusLiveLink(false);
                  this.setFocusSearchLink(true);
                  this.setFocusSettings(false);
                } else if (this.focusSearchLink) {
                  this.setFocusSettings(true);
                  this.setFocusSearchLink(false);
                } else {
                  this.setFocusSettings(true);
                  this.setFocusSearchLink(false);
                  this.setFocusLiveLink(false);
                  this.setFocusKidjoWorldLink(false);
                }
                break;
              }
              case VK_LEFT: {
                if (this.focusSettings) {
                    this.setFocusSearchLink(true);
                    this.setFocusSettings(false);
                } else if (this.focusSearchLink) {
                    this.setFocusLiveLink(true);
                    this.setFocusSearchLink(false);
                  } else if (this.focusLiveLink) {
                    this.setFocusLiveLink(false);
                    this.setFocusKidjoWorldLink(!this.isVewd());
                  } else {
                    this.setFocusKidjoWorldLink(!this.isVewd());
                    this.setFocusLiveLink(false);
                    this.setFocusSettings(false);
                    this.setFocusSearchLink(false);
                  }
                break;
              }
              case VK_MENU: {
                this.showSettings();

                break;
              }
              case VK_ENTER: {
                if (this.focusSettings) {
                  this.setFocusSettings(false);
                  this.showSettings();
                } else if (this.focusSearchLink) {
                  this.setFocusSearchLink(false);
                  this.showSearch();
                } else if (this.focusLiveLink) {
                  this.setFocusLiveLink(false);
                  this.goLive();
                } else if (this.focusKidjoWorldLink) {
                  this.setFocusKidjoWorldLink(false);
                  this.goToKidjoWorld();
                }

                break;
              }
            }
          } catch (error) {
            switch (event.code) {
              case 'ArrowRight': {
                if (this.focusKidjoWorldLink) {
                  this.setFocusKidjoWorldLink(false);
                  this.setFocusLiveLink(true);
                } else if (this.focusLiveLink) {
                  this.setFocusLiveLink(false);
                  this.setFocusSearchLink(true);
                  this.setFocusSettings(false);
                } else if (this.focusSearchLink) {
                  this.setFocusSettings(true);
                  this.setFocusSearchLink(false);
                } else {
                  this.setFocusSettings(true);
                  this.setFocusSearchLink(false);
                  this.setFocusLiveLink(false);
                  this.setFocusKidjoWorldLink(false);
                }
                break;
              }
              case 'ArrowLeft': {
                if (this.focusSettings) {
                    this.setFocusSearchLink(true);
                    this.setFocusSettings(false);
                } else if (this.focusSearchLink) {
                    this.setFocusLiveLink(true);
                    this.setFocusSearchLink(false);
                  } else if (this.focusLiveLink) {
                    this.setFocusLiveLink(false);
                    this.setFocusKidjoWorldLink(!this.isVewd());
                  } else {
                    this.setFocusKidjoWorldLink(!this.isVewd());
                    this.setFocusLiveLink(false);
                    this.setFocusSettings(false);
                    this.setFocusSearchLink(false);
                  }

                break;
              }
              case 'ArrowDown': {
                this.setActiveHeaderBarNav(false);
                this.setFocusLiveLink(false);
                this.setFocusSettings(false);
                this.setFocusSearchLink(false);
                this.setFocusKidjoWorldLink(false);
                break;
              }
              case 'Enter': {
                if (this.focusSettings) {
                  this.setFocusSettings(false);
                  this.showSettings();
                } else if (this.focusSearchLink) {
                  this.setFocusSearchLink(false);
                  this.showSearch();
                } else if (this.focusLiveLink) {
                  this.setFocusLiveLink(false);
                  this.goLive();
                } else if (this.focusKidjoWorldLink) {
                  this.setFocusKidjoWorldLink(false);
                  this.goToKidjoWorld();
                }
                break;
              }
            }
          }
        }
      },
      showSearch() {
        soundPlayer(soundList.general);
        this.$router.push({ name: 'search' });
      },
      showSettings() {
        this.ageSettingFor('settings');
        this.showAgeSetting();
      },
      isVewd() {
        var ua = navigator.userAgent.toLowerCase();
        var vewdKeywords = ['omi'];
        for (var i = 0; i < vewdKeywords.length; i++) {
            if (ua.indexOf(vewdKeywords[i]) !== -1) {
                return true;
            }
        }
        return false;
      },
      showAgeSetting() {
        soundPlayer(soundList.general);
        this.displayAgeSetting(true);
      },
      async goLive() {        
        soundPlayer(soundList.general);
        if (this.getPremium) {
          this.$store.dispatch('settings/setDisplayVideoLoader', true);
          // get filter Settings
          const type = this.getContentType;
          const age = this.getAge;
          const lang = SettingStorage.getOptionValue(itemList.language);

          // get Videos Ids
          const itemsList = await LiveService.getVideosIds(type, age);

          soundPlayer(soundList.general);

          // play the first item from the array
          const first = itemsList.slice(0, 1).shift();

          // remove the first item from array so it won't play second time
          itemsList.shift();

          // set playList
          this.setVideoList(itemsList);

          // activate Live mode
          this.setLiveMode(true);

          // play
          this.$ga.event('video', 'play', `${first.identifier}`);
          this.$router.push({ name: 'player', params: { videoId: first.identifier } });
          this.setActiveHeaderBarNav(false);
          this.$store.dispatch('settings/setDisplayVideoLoader', false);

        } else {
          // set banner to active state
          this.setBannerState(true);
          // show banner
          this.showAuthBanner = true;
          // this.$store.dispatch('settings/setDisplayLoader', false);
        }
      },
    },
    mounted() {
      this.setFocusSettings(false);
      this.display = this.excludedRoutes.indexOf(this.$route.name || '') === -1;
      document.addEventListener('keyup', this.handleKeyboard);
    },
    destroyed() {
      document.removeEventListener('keyup', this.handleKeyboard);
    },
    watch: {
      $route() {
        this.display = this.excludedRoutes.indexOf(this.$route.name || '') === -1;
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../assets/styles/breakpoints.scss';

  .top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    flex-wrap: nowrap; /* Ensures no wrapping */
    z-index: 100;
    gap: 10px;

    @media (orientation: portrait) {
      &--has-height {
        box-sizing: border-box;
        height: 74px;
        padding: 10px 10px 0;
      }
    }

    // img {
    //   vertical-align: middle;
    // }

    .home-live-section {
      display: flex;
      position: absolute;
      align-items: center;
      max-height: 70px;
      gap:20px;
      top: 10px;
      left: 10px;
      @media (max-width: 412px) {
        gap: 15px;
      }
      @media (max-width: 390px) {
        gap: 10px;
      }
    
      .kidjo-home {
        cursor: pointer;
        display: flex;
        outline: none;
        img {
          width: 60px;
          // height: 60px;

          @media (min-width: $breakpoint-lg) {
            width: 75px;
            // height: 75px;
          }
          @media (max-width: 390px) {
            width: 50px;
            // height: 50px;
          }
        }
        .lottie-player {
          display: none;
          max-width: 60px;
          // max-height: 60px;

          @media (min-width: $breakpoint-lg) {
            max-width: 75px;
            // max-height: 75px;
          }
          @media (max-width: 390px) {
            width: 50px;
            // height: 50px;
          }
        }
        &:hover,
        &:focus {
          .lottie-player {
            display: block;
          }
          > img {
            display: none;
          }
        }
        &.active {
          .lottie-player {
            display: block;
          }

          > img {
            display: none;
          }
        }
      }
      .live-btn {
        cursor: pointer;
        display: flex;
        .lottie-player {
          display: none;
          // width:110px;

          @media (min-width: $breakpoint-lg) {
            width: 147px;
          }
          @media (max-width: 390px) {
            width: 95px;
          }
        }
        img {
          @media (min-width: $breakpoint-lg) {
            width: 147px;
          }
          @media (max-width: 390px) {
            width: 95px;
          }
        }
        &:hover,
        &:focus {
          .lottie-player {
            display: block;
          }
          > img {
            display: none;
          }
        }
        &.active {
          .lottie-player {
            display: block;
          }

          > img {
            display: none;
          }
        }
      }
    }
    .user-controls {
      display: flex;
      position: absolute;
      align-items: center;
      max-height: 70px;
      gap:20px;
      top: 10px;
      right: 10px;
      @media (max-width: 412px) {
        gap: 15px;
      }
      @media (max-width: 390px) {
        gap: 10px;
      }
      .search {
        display: flex;
        cursor: pointer;
        outline: none;
        img {
          width: 60px;
          // height: 60px;

          @media (min-width: $breakpoint-lg) {
            width: 75px;
            // height: 75px;
          }
          @media (max-width: 390px) {
            width: 50px;
            // height: 50px;
          }
        }
        .lottie-player {
          display: none;
          max-width: 50px;
          // max-height: 60px;

          @media (min-width: $breakpoint-lg) {
            max-width: 65px;
            // max-height: 75px;
          }
        }
        &:hover,
        &:focus {
          .lottie-player {
            display: block;
          }
          > img {
            display: none;
          }
        }
        &.active {
          .lottie-player {
            display: block;
          }

          > img {
            display: none;
          }
        }
      }
      .settings {
        cursor: pointer;
        outline: none;
        display: flex;
        align-items: center;
        padding: 12px 12px;
        background-color: #2192C5;
        border: none;
        border-radius: 50px;
        font-family: 'Nunito-ExtraBold', serif;
        color: #fff;
        font-size: 22px;

        @media (min-width: $breakpoint-lg) {
          font-size: 26.83px;
        }
        @media (max-width: 390px) {
          font-size: 20px;
          padding: 8px 8px;
        }

        span {
          margin-inline: 10px;
        }
        img {
          width: 35px;
          height: 35px;
          @media (min-width: $breakpoint-lg) {
            width: 50px;
            height: 50px;
          }
        }
        .lottie-player {
          display: none;
          width: 35px;
          height: 35px;

          @media (min-width: $breakpoint-lg) {
            width: 50px;
            height: 50px;
          }
        }
        &:hover,
        &:focus {
          .lottie-player {
            display: block;
          }
          > img {
            display: none;
          }
        }
          &.active {
            .lottie-player {
              display: block;
            }

            > img {
              display: none;
            }
        }
      }
    }
  }
</style>